export default __webpack_public_path__ + "static/media/Document_management.ca78bc2c.png";